export default __webpack_public_path__ + "static/Header-527abed19f496a516802cf82ea0c022a.png";